class EmoireStickyATC {
  constructor() {
    this.sticky = document.querySelector('.emoire-sticky-atc');

    if (!this.sticky) return;

    this.button = this.sticky.querySelector('.emoire-sticky-button');

    this.bindEvents();
    this.observeMainButton();
  }

  get mainButton() {
    return document.querySelector('button[name="add"]');
  }

    bindEvents() {
      this.button?.addEventListener('click', () => {
        const btn = this.mainButton;

        if (btn && !btn.disabled) {
          btn.click();
        }
      });
    }

    observeMainButton() {
    const button = this.mainButton;

    if (!button) return;

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.sticky.classList.toggle(
          'is-visible',
          !entry.isIntersecting
        );
      },
      {
        threshold: 0,
      }
    );

    this.observer.observe(button);
  }
}

let emoireStickyATC;

function initEmoireStickyATC() {
  emoireStickyATC = new EmoireStickyATC();
}

document.addEventListener(
  'DOMContentLoaded',
  initEmoireStickyATC
);

document.addEventListener('shopify:section:load', () => {
  initEmoireStickyATC();
});